<template>
    <tr>
        <td><router-link :to="{path: '/reports/appeal/' + id}">{{ title }}</router-link></td>
        <td><span class="icon-Check green"></span>Активный</td>
    </tr>
</template>

<script>
    export default {
        props: ['id', 'title', 'questions', 'finish_checklists'],
    }
</script>